/* eslint-disable react/require-default-props,react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class ClickableElement extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.number,
      PropTypes.string,
    ]),
    onClick: PropTypes.func,
    className: PropTypes.string,
    hoverable: PropTypes.bool,
    disabled: PropTypes.bool,
    ariaLabel: PropTypes.string,
  };

  el = null;

  @autobind
  handleMouseUp() {
    this.el.blur();
  }

  @autobind
  handleKeyDown(e) {
    const code = e.which;

    // trigger return/space keys
    if (code === 13 || code === 32) {
      this.el.click();
    }
  }

  @autobind
  handleClick(event) {
    if (!this.props.disabled && this.props.onClick) this.props.onClick(event);
  }

  render() {
    const {
      children,
      className,
      hoverable,
      disabled,
      onClick,
      ariaLabel,
      ...other
    } = this.props;

    return (
      <div
        {...{ children, className, ...other }}
        onClick={this.handleClick}
        role="button"
        styleName={classNames('root', {
          'root--hoverable': hoverable,
          disabled,
        })}
        tabIndex="0"
        ref={node => (this.el = node)}
        onMouseUp={this.handleMouseUp}
        onKeyDown={this.handleKeyDown}
        aria-label={ariaLabel || ''}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClickableElement/index.jsx